import { useContext } from 'react';
import { UserContext } from '../../../context/user/UserContext';

import { UserDetailContext } from '../../../context/userDetails/UserDetailContext';

export default function SwitchRoleToggle() {
  const { user, switchRole } = useContext(UserContext);
  const { userDetail } = useContext(UserDetailContext);
  const isPending = userDetail?.approval_status === 'PENDING';

  return (
    <div className="flex items-center bg-gray-50 border border-gray-200 rounded-full shadow-sm p-1">
      <button
        onClick={() => switchRole('user')}
        className={`px-4 py-1.5 rounded-full text-xs font-bold uppercase tracking-wider transition-all duration-300 ${
          user.active_role === 'user'
            ? 'bg-rose-500 text-white shadow-md'
            : 'text-gray-500 hover:text-gray-700'
        }`}
      >
        Client
      </button>

      <button
        onClick={() => switchRole('artisan')}
        className={`px-4 py-1.5 rounded-full text-xs font-bold uppercase tracking-wider transition-all duration-300 flex items-center gap-2 ${
          user.active_role === 'artisan'
            ? 'bg-amber-500 text-white shadow-md'
            : 'text-gray-500 hover:text-gray-700'
        }`}
      >
        {isPending ? (
          <>
            <span className="w-1.5 h-1.5 rounded-full bg-white animate-pulse" />
            Pending Artisan
          </>
        ) : (
          'Artisan'
        )}
      </button>
    </div>
  );
}
